var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8269 25.6713C17.6402 25.49 17.3903 25.3886 17.1301 25.3886H13.0835C11.4266 25.3886 10.0835 24.0455 10.0835 22.3886V17.6226C10.0835 15.9657 11.4266 14.6226 13.0835 14.6226H17.0545C17.3129 14.6226 17.5612 14.5226 17.7474 14.3436L23.0376 9.26002C24.944 7.42802 28.1163 8.77914 28.1163 11.4232V28.5702C28.1163 31.222 24.9279 32.5697 23.0259 30.722L17.8269 25.6713ZM17.9416 23.3886C18.2018 23.3886 18.4518 23.49 18.6384 23.6713L24.4195 29.2874C25.0535 29.9033 26.1163 29.4541 26.1163 28.5702V11.4232C26.1163 10.5418 25.0589 10.0914 24.4234 10.7021L18.5526 16.3436C18.3663 16.5226 18.118 16.6226 17.8597 16.6226H13.0835C12.5312 16.6226 12.0835 17.0703 12.0835 17.6226V22.3886C12.0835 22.9409 12.5312 23.3886 13.0835 23.3886H17.9416Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.54ee5f277adf335b10e2aa4a922c8ae3.svg";
export { ForwardRef as ReactComponent };